import React from "react";
import { Navigate } from "react-router-dom";
import FullScreenLoader from "@/components/ui/FullScreenLoader";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRoles } from "@/hooks/useUserRoles";
import { UserRole } from "@/types/auth";
import { PATHS } from "./paths";

// Área autenticada: espera a verificação de sessão e manda para o login.
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loggedIn, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!loggedIn) return <Navigate to={PATHS.signIn} replace />;
  return <>{children}</>;
};

// Telas de entrada (login, cadastro): quem já está logado vai para o painel.
export const PublicOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loggedIn, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (loggedIn) return <Navigate to={PATHS.dash} replace />;
  return <>{children}</>;
};

// Páginas restritas a alguns papéis (ex.: Integrações e Usuários só para
// Administrador). O backend valida de novo; aqui só evitamos a tela quebrada.
export const RequireRole: React.FC<{ roles: UserRole[]; children: React.ReactNode }> = ({
  roles,
  children,
}) => {
  const { hasAnyRole } = useUserRoles();
  if (!hasAnyRole(roles)) return <Navigate to={PATHS.home} replace />;
  return <>{children}</>;
};
